import React, { useState, useEffect } from 'react'
import {
    useNavigate, useLocation
} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectDataset, openLeftPanel, updTableModal } from "./../../services/StoreContainer/actionCreators";
import * as actionTypes from "./../../services/StoreContainer/actionTypes";

import "./styles.scss"
import CloseCross from "../../assets/closeCross.svg"

function MainContent() {
    const currentPath = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const datasetsContainer = useSelector((store) => { return store.datasetsReducer });

    useEffect(() => {
        if (document.getElementById("LkContainer")) document.getElementById("LkContainer").style.height = window.innerHeight / 100 * 7 > 55 ? (window.innerHeight - 55) + 'px' : '93%';
        // console.log(window.innerHeight / 100 * 7);
    }, [])

    function openNavElement(event, link, tableName) {
        event.preventDefault();
        event.stopPropagation();
        // console.log(event, window.location.href + '/' + link)
        closeMenu()
        if (window.location.href.endsWith('/MyDatasets') || window.location.href.endsWith('/lk')) {
            if (event.ctrlKey || event.metaKey) {
                window.open(+ '/lk/' + link)
            }
            else {
                navigate('/lk/' + link)
            }
        }
        dispatch(updTableModal(true, tableName));
    }

    function isActive(link) {
        let currPath = currentPath && currentPath.pathname.substring(currentPath.pathname.lastIndexOf('/') + 1)
        return (link === currPath);
    }

    function closeMenu() {
        console.log('closemenu')
        let menu = document.getElementById('MainMenu')
        if (menu && menu.style) menu.style.display = 'none'
    }

    let goToLeftPanel = (dataset, type) => {
        closeMenu();
        dispatch(selectDataset(dataset));
        dispatch(openLeftPanel(type));
    }

    let lastDatasets = null;
    try {
        lastDatasets = JSON.parse(localStorage.getItem('lastDatasets'));
    } catch (error) { }
    lastDatasets = lastDatasets || [];
    //потому что какие-то из недавних датасетов могли уже быть удалены, и перейти на них нельзя
    if (datasetsContainer && datasetsContainer.datasets) {
        lastDatasets = lastDatasets.filter(d1 => {
            let datasetExists = datasetsContainer.datasets.find(d2 => (d2.dataset === d1.dataset));
            return datasetExists;
        })
    }

    return <div className="menuDiv-blur" id="MainMenu" key={"keyMainMenu"}>
        <div className="menuDiv" id="LkContainer" key={"keyMainMenuLkContainer"}>

            <h3 className={"bigText"}>Наборы данных</h3>

            <div onClick={(e) => { openNavElement(e, "MyDatasets") }} className={"textStyle " + (isActive("MyDatasets") ? 'active' : '')}>Загруженные наборы</div>
            <div onClick={(e) => { goToLeftPanel(null, actionTypes.IMPORT_DATASET) }} className={"textStyle"}>Добавить файл</div>

            {(lastDatasets.length > 0) &&
                <div>
                    <div className={"textStyle noClick"}>Недавние</div>
                    {lastDatasets.map((item, index) => {
                        if (index !== 0
                            || window.location.href.endsWith('/MyDatasets')
                            || window.location.href.endsWith('/lk')
                        )
                            return <>
                                <div
                                    key={"lastDatasets_" + index}
                                    onClick={(e) => {
                                        let dataset = datasetsContainer.datasets.find(d => (d.dataset === item.dataset));
                                        if (dataset) {
                                            dispatch(selectDataset(dataset));
                                            openNavElement(e, "DatasetTable", dataset.name);
                                        }
                                    }} className={"textStyle listItem"}>{"- " + item.name}</div>
                            </>
                    })}
                </div>
            }

            <div className='merginBetween' />

            <h3 className={"bigText"}>Тарифы</h3>

            <div onClick={(e) => {
                closeMenu();
                dispatch(openLeftPanel(actionTypes.MY_TARIF));
            }} className={"textStyle"}>Активный тариф</div>

            <div className='closeMenu' onClick={closeMenu}><img className='closeIcon' src={CloseCross} alt='closeIcon' /></div>

        </div> </div >

}

export default MainContent;
